import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IPortfolioTooltipBuilding } from '@api/types'
import { PortfolioTooltipBuildingFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IProps {
  id: string
  assignmentPlanId?: string
}
interface IPayload {
  name: string
  portfolio: IPortfolioTooltipBuilding
}

const mutateHandler = handleFetchResult<IPayload, any>({
  handler: (data) => data,
  name: 'Contract',
})

export default function building({ id, assignmentPlanId }: IProps): Promise<IPayload> {
  const variables = {
    id,
    assignmentPlanId,
  }
  return client.gql.query({ query: buildingPortfolioTooltipQuery, variables }).then(mutateHandler)
}

export const buildingPortfolioTooltipQuery = gql`
  query buildingPortfolioTooltip($id: ID!, $assignmentPlanId: ID) {
    node(id: $id) {
      ... on Building {
        name
        portfolio(assignmentPlanId: $assignmentPlanId) {
          ...PortfolioTooltipBuildingFragment
        }
      }
    }
  }
  ${PortfolioTooltipBuildingFragment}
`
